import { useCallback } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { type ModalHandler } from '../modals';
import { clearModalParams } from '../routes';

/**
 * Hook that provides a standardized way to close URL-triggered modals.
 * Clears modal params from URL and closes the modal.
 * This ensures URL is the source of truth for modal state.
 */
export const useModalClose = (modal: ModalHandler) => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    const params = new URLSearchParams(location.search);
    clearModalParams(params);
    const newSearch = params.toString();
    navigate(`${location.pathname}${newSearch ? `?${newSearch}` : ''}`, { replace: true });
    modal.hide();
    modal.remove();
  }, [modal, navigate, location.search, location.pathname]);
};
